import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  textWidgetModalSave: {
    defaultMessage: 'Save',
    description: 'Save button text in the text widget edit modal',
    id: 'aKWWJ9',
  },
  textWidgetModalCancel: {
    defaultMessage: 'Cancel',
    description: 'Cancel button text in the text widget edit modal',
    id: 'KEKwTa',
  },
  textWidgetModalHeader: {
    defaultMessage: 'Edit Expression',
    description: 'Header text in the text widget edit modal',
    id: 'd3qWeR',
  },
});
